import React, { useCallback } from 'react';
import { CSSTransition } from 'react-transition-group';

import css from './TransitionComponent.module.scss';

interface Props {
  visible: boolean;
  children: React.ReactNode;
  type: 'opacity' | 'transformRight' | 'transformBottom';
}
const TransitionComponent: React.FC<Props> & { OPACITY_TRANSITION_TIME: number } = (props) => {
  const { visible, children, type } = props;

  const enter = () => {
    switch (type) {
      case 'opacity':
        return css.opacityAnimEnter;
      case 'transformRight':
        return css.transformRightAnimEnter;
      case 'transformBottom':
        return css.transformBottomAnimEnter;
      default:
        break;
    }
  };

  const enterActive = () => {
    switch (type) {
      case 'opacity':
        return css.opacityAnimEnterActive;
      case 'transformRight':
        return css.transformRightAnimEnterActive;
      case 'transformBottom':
        return css.transformBottomAnimEnterActive;
      default:
        break;
    }
  };

  const exit = () => {
    switch (type) {
      case 'opacity':
        return css.opacityAnimExit;
      case 'transformRight':
        return css.transformRightAnimExit;
      case 'transformBottom':
        return css.transformBottomAnimExit;
      default:
        break;
    }
  };

  const exitActive = () => {
    switch (type) {
      case 'opacity':
        return css.opacityAnimExitActive;
      case 'transformRight':
        return css.transformRightAnimExitActive;
      case 'transformBottom':
        return css.transformBottomAnimExitActive;
      default:
        break;
    }
  };

  const cssProperties = useCallback(() => {
    return {
      enter: enter(),
      enterActive: enterActive(),
      exit: exit(),
      exitActive: exitActive(),
    };
  }, [type]);

  return (
    <CSSTransition
      in={visible}
      timeout={parseInt(type === 'opacity' ? css.opentransitionopacity : css.opentransitiontransform, 10)}
      unmountOnExit
      classNames={cssProperties()}
    >
      {children}
    </CSSTransition>
  );
};

TransitionComponent.OPACITY_TRANSITION_TIME = parseInt(css.opentransitionopacity, 10);

export default TransitionComponent;
